module.exports = __webpack_public_path__ + "img/logo_GI_bianco.4de83a0e.png";